import AppApi from "./AppApi";
import AppStore from "../stores/Store";

export default class MobileUserApi {
  constructor(private api: AppApi, private store: AppStore) {
    this.api = api;
    this.store = store;
  }
  
  async getUserInfo(shortToken: string): Promise<void> {
    const response = await this.api.client.get(
      `/mobile/users/api/v1/current?short_token=${encodeURIComponent(shortToken)}`
    );
    this.store.authStore.saveCurrentUser(response.data);
  }

  async getLinkedServices(shortToken: string) : Promise<boolean> {
    const result = await this.api.client.get(`/mobile/users/api/v1/linked-services?short_token=${encodeURIComponent(shortToken)}`);
    return this.store.mobileUserStore.setLinkedServices(result.data);
  }
}